var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.028 6.333h-.001a.29.29 0 0 1-.258-.157c-.41-.79-.87-1.435-1.406-1.97a.291.291 0 1 1 .413-.412c.468.467.88 1.007 1.253 1.644.88-1.533 1.965-2.78 3.229-3.714a.292.292 0 0 1 .346.47c-1.319.973-2.435 2.314-3.318 3.985a.29.29 0 0 1-.257.155z"
  })));
};
export default SvgCheckIcon;